// The on-demand course's own words, ported from PCFL v3 (reference/pcfl-v3/source/app.jsx) and put
// through Adam's writing rules. No board draws these pages, so every line here is on the list for
// Adam's walkthrough. Words that come from the database (module titles and lines, step titles and
// bodies, homework, episode titles) aren't here.
export const COPY = {
  // Home
  welcome: name => (name ? `Welcome back, ${name}` : 'Welcome back'),
  whereKicker: "Where you're up to",
  pentagonKey: "Solid: homework done. Dashed: where you're up to.",
  pentagonTitle: 'Progress through the 5 Ms',
  upNext: 'Up next',
  modulesDone: (n, total) => `${n} of ${total} modules done`,
  certificate: 'See your certificate',

  // Homework
  homeworkFoot: 'Nobody marks it and nothing gets handed in. Your ticks save as you go.',
  homeworkDone: 'Done',
  homeworkOf: (done, total) => `${done} of ${total}`,
  saveFailed: "That didn't save. Check your connection and try again.",

  // Start here
  startKicker: 'Pre-course module',
  startTitle: 'Start here',
  startLede: (before, done, total) => `Do these before ${before}, in order. ${done} of ${total} done.`,
  startLedeAny: (done, total) => `Do these first, in order. ${done} of ${total} done.`,
  stepWord: n => `Step ${n}`,
  stepDoneWord: 'Done',
  stepOf: (n, total, optional) => `Step ${n} of ${total}${optional ? ', optional' : ''}`,
  back: 'Back',
  nextStep: 'Next step',
  backHome: 'Back to Home',
  startDone: 'Start here done',
  ticksItself: "This ticks itself once you've watched it.",
  stillToDo: titles => `Still to do: ${titles.join(', ')}.`,
  noSheets: 'Your sheets appear here.',
  openTarget: title => `Open ${title}`,
  notUp: "This recording isn't up yet.",
  chapters: 'Chapters',
  chaptersLine: (lessons, length) => (length ? `${lessons}, ${length}` : lessons),
  openRecording: name => `Open ${name} on its own page`,
  posterChapters: phone => (phone ? 'Tap a chapter to jump to it' : 'Press a chapter to jump straight to it'),

  // Recordings
  recKicker: 'Recordings',
  recTitle: 'Every session, as often as you like',
  recLede: "Every session, split into chapters by lesson. Slides, sheets and the module's homework sit beside it.",
  recSearch: 'Search lessons, like brokers',
  recSearchLabel: 'Search recordings',
  all: 'All',
  beforeFirst: label => `Before ${label}`,
  homeworkChip: (done, total) => `Homework ${done} of ${total}`,
  homeworkChipDone: 'Homework done',
  hitAt: time => ` at ${time}`,
  noMatch: term => `Nothing matches "${term}". Try another word, or clear the search.`,
  noRecordings: 'No recordings here yet.',

  // Pick your patch (PCFL's own: the on-demand type is PCFL in phase 1)
  patchKicker: 'Bonus',
  patchTitle: 'Pick your patch',
  patchLede: 'Watch me do the desk research from lesson 0.4 on a real town, start to finish. Have your area research sheet open and do yours alongside me.',
  watch: 'Watch',
  carryOn: 'Carry on',
  watched: 'Watched',
  carryOnFrom: time => `Carry on from ${time}`,
  pressPlay: 'Press play to start',
  videoNotUp: "This video isn't up yet.",
  episodesWatched: (n, total) => `${n} of ${total} watched.`,
  yourSheet: 'Your sheet',

  // Resources
  bonuses: 'Bonuses',
  patchCardLine: 'Watch me do the desk research for a patch on a real town, start to finish.',
  patchCardButton: 'Watch the series',
  emptyResources: name => `Nothing here yet. Anything Adam adds for ${name} shows up here.`,
}
